// extracted by mini-css-extract-plugin
export default {"head":"MainHeader_head__dJATd"};